export const getCurrentMinutes = (): number => {
  const now = new Date();

  return now.getHours() * 60 + now.getMinutes();
};
